
import Component from "vue-class-component";
import {
    ApiException,
    QualificationActions,
    QualificationsClient,
    TrainingQualificationDetailsModel,
    TrainingQualificationModel,
    TrainingQualificationOptions
} from "@/api-client";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";
import {QualificationAddBase} from "@/features/documents/qualifications/views/QualificationAddBase";
import {Prop, Vue} from "vue-property-decorator";
import {NavigationGuardNext} from "vue-router/types/router";
import TrainingQualificationUpsertForm from "@/features/documents/qualifications/components/TrainingQualificationUpsertForm.vue";

interface Props {
    seafarerId: string;
    qualificationPreloadedActions: QualificationActions;
    options: TrainingQualificationOptions;
    existingQualification: TrainingQualificationDetailsModel;
}

@Component({
    components: {
        TrainingQualificationUpsertForm,
        FormLayout
    },
    async beforeRouteEnter(to, from, next: NavigationGuardNext<TrainingQualificationEdit>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        const qualificationId = to.params.id
        Promise.all([
            new QualificationsClient().availableActions(props.seafarerId, qualificationId),
            new QualificationsClient().trainingOptions(),
            new QualificationsClient().getTrainingQualification(qualificationId),
        ]).then(values => {
            props.qualificationPreloadedActions = values[0];
            props.options = values[1];
            props.existingQualification = values[2];
            next();
        }).catch(e => next(e))
    }
})
export default class TrainingQualificationEdit extends QualificationAddBase<TrainingQualificationModel> implements Props {
    @Prop({required: true})
    qualificationPreloadedActions!: QualificationActions;

    @Prop({required: true})
    existingQualification!: TrainingQualificationDetailsModel;

    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    options!: TrainingQualificationOptions;

    initialModel: TrainingQualificationModel = new TrainingQualificationModel({
            ...this.existingQualification,
            existingFiles: this.existingQualification.files,
            addedFiles: [],
            removedFiles: []
    });

    async editQualification(model: TrainingQualificationModel): Promise<void> {
        /* QualificationAddBase already has a submit function, but it only does "add", and
               it is not used here (shouldn't be either, it doesn't do "edit").
               Best would be to make a similar "edit" function in Base, but due to time limitations
               there is a duplicated "editQualification" function both here and EducationalQualificationEdit.vue :) */

        return await new QualificationsClient().edit(this.existingQualification.id, model)
            .then(async result => {
                const route = this.returnRoute
                ? this.returnRoute
                : { name: "training-details" };

                route.params = {
                    ...route.params,
                    seafarerId: this.existingQualification.seafarerId,
                    id: this.existingQualification.id
                }

                await this.$router.replace(route);
            });
    }
}
